<div class="notification-type-header">
    <label class="fw-bold">{{name}}</label>
    <on-off-tri-toggle [active]="active" [partial]="!status?.allOn && !status?.allOff" [boolValue]="status?.allOn" (onChange)="changeAllToggles($event)"></on-off-tri-toggle>
    <div>{{localize(langSection.NotificationSettings, langText.AllToggles)}}</div>
</div>
